import { ConnectionStatus } from '@amityco/js-sdk';
import React, { useContext, useEffect, useMemo, useState } from 'react';
const SDKContext = React.createContext({});
export const useSDK = () => useContext(SDKContext);
export const SDKProvider = ({ children, client }) => {
    var _a, _b, _c, _d;
    const [connectionStatus, setConnectionStatus] = useState(ConnectionStatus.NotConnected);
    useEffect(() => {
        if (client) {
            setConnectionStatus(client.connectionStatus);
            client.on('connectionStatusChanged', ({ newValue }) => setConnectionStatus(newValue));
        }
    }, [client]);
    const value = useMemo(() => {
        var _a, _b, _c, _d, _e;
        return ({
            client,
            connected: connectionStatus === ConnectionStatus.Connected,
            currentUserId: (_b = (_a = client === null || client === void 0 ? void 0 : client.currentUser) === null || _a === void 0 ? void 0 : _a.model) === null || _b === void 0 ? void 0 : _b.userId,
            userRoles: (_d = (_c = client === null || client === void 0 ? void 0 : client.currentUser) === null || _c === void 0 ? void 0 : _c.model) === null || _d === void 0 ? void 0 : _d.roles,
            networkSettings: (_e = client === null || client === void 0 ? void 0 : client.networkSettings) !== null && _e !== void 0 ? _e : {},
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        client,
        connectionStatus,
        (_b = (_a = client === null || client === void 0 ? void 0 : client.currentUser) === null || _a === void 0 ? void 0 : _a.model) === null || _b === void 0 ? void 0 : _b.userId,
        (_d = (_c = client === null || client === void 0 ? void 0 : client.currentUser) === null || _c === void 0 ? void 0 : _c.model) === null || _d === void 0 ? void 0 : _d.roles,
        client === null || client === void 0 ? void 0 : client.networkSettings,
    ]);
    return React.createElement(SDKContext.Provider, { value: value }, children);
};
const withSDK = (Component) => (props) => {
    const sdkData = useSDK();
    return React.createElement(Component, Object.assign({}, sdkData, props));
};
export default withSDK;
//# sourceMappingURL=withSDK.js.map